import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  copyright:{
    color: '#ffffff',
    fontSize: 14,
    lineHeight: '18px',
    padding: '5px 5px 12px 5px'
  }
}));

export default useStyles